module.exports = __webpack_public_path__ + "static/media/kcc-short-introduction-yueyu-new.8895b100.mp4";